import "./browserPatches";
import { getConfig } from "common/src/config";
import { QueryClientProvider } from "@tanstack/react-query";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { ExploreApplicationsPage } from "./features/discovery/ExploreApplicationsPage";
import { DataLayer, DataLayerProvider } from "data-layer";
import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Route, Routes } from "react-router-dom";
import { WagmiProvider } from "wagmi";
import queryClient, { config } from "./app/wagmi";
import { RoundProvider } from "./context/RoundContext";
import { initDatadog } from "./datadog";
import { initPosthog } from "./posthog";
import reportWebVitals from "./reportWebVitals";
import { initTagmanager } from "./tagmanager";
import sdk from "@farcaster/frame-sdk";
import "./index.css";

// Routes
import { ChakraProvider } from "@chakra-ui/react";
import AccessDenied from "./features/common/AccessDenied";
import Auth from "./features/common/Auth";
import NotFound from "./features/common/NotFoundPage";
import { ViewContributionHistoryPage } from "./features/contributors";
import ExploreRoundsPage from "./features/discovery/ExploreRoundsPage";
import LandingPage from "./features/discovery/LandingPage";
import ThankYou from "./features/round/ThankYou";
import ViewCart from "./features/round/ViewCartPage/ViewCartPage";
import ViewProjectDetails from "./features/round/ViewProjectDetails";
import ViewRound from "./features/round/ViewRoundPage";
import AlloWrapper from "./features/api/AlloWrapper";
import { PostHogProvider } from "posthog-js/react";
import ViewProject from "./features/projects/ViewProject";
import { ExploreProjectsPage } from "./features/discovery/ExploreProjectsPage";
import { DirectAllocationProvider } from "./features/projects/hooks/useDirectAllocation";
import { DonateToGitcoinProvider } from "./features/round/DonateToGitcoinContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
initDatadog();
initTagmanager();
const posthog = initPosthog();
const root = ReactDOM.createRoot(document.getElementById("root"));
const GRANTS_STACK_DATA_APPLICATIONS_PAGE_SIZE = 50;
const dataLayer = new DataLayer({
  search: {
    baseUrl: getConfig().dataLayer.searchServiceBaseUrl,
    pagination: {
      pageSize: GRANTS_STACK_DATA_APPLICATIONS_PAGE_SIZE
    }
  },
  ipfs: {
    gateway: getConfig().ipfs.baseUrl
  },
  indexer: {
    baseUrl: `${getConfig().dataLayer.gsIndexerEndpoint}/graphql`
  }
});
root.render(/*#__PURE__*/_jsx(React.StrictMode, {
  children: /*#__PURE__*/_jsx(PostHogProvider, {
    client: posthog,
    children: /*#__PURE__*/_jsx(WagmiProvider, {
      config: config,
      children: /*#__PURE__*/_jsx(QueryClientProvider, {
        client: queryClient,
        children: /*#__PURE__*/_jsx(RainbowKitProvider, {
          children: /*#__PURE__*/_jsx(ChakraProvider, {
            children: /*#__PURE__*/_jsx(DonateToGitcoinProvider, {
              children: /*#__PURE__*/_jsx(DirectAllocationProvider, {
                children: /*#__PURE__*/_jsx(AlloWrapper, {
                  children: /*#__PURE__*/_jsx(RoundProvider, {
                    children: /*#__PURE__*/_jsx(DataLayerProvider, {
                      client: dataLayer,
                      children: /*#__PURE__*/_jsx(HashRouter, {
                        children: /*#__PURE__*/_jsxs(Routes, {
                          children: [/*#__PURE__*/_jsx(Route, {
                            element: /*#__PURE__*/_jsx(Auth, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/",
                            element: /*#__PURE__*/_jsx(LandingPage, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/rounds",
                            element: /*#__PURE__*/_jsx(ExploreRoundsPage, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/round/:chainId/:roundId",
                            element: /*#__PURE__*/_jsx(ViewRound, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/round/:chainId/:roundId/:applicationId",
                            element: /*#__PURE__*/_jsx(ViewProjectDetails, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/projects",
                            element: /*#__PURE__*/_jsx(ExploreProjectsPage, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/projects/:projectId",
                            element: /*#__PURE__*/_jsx(ViewProject, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/cart",
                            element: /*#__PURE__*/_jsx(ViewCart, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/thankyou",
                            element: /*#__PURE__*/_jsx(ThankYou, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/contributors/:address",
                            element: /*#__PURE__*/_jsx(ViewContributionHistoryPage, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/access-denied",
                            element: /*#__PURE__*/_jsx(AccessDenied, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "/collections/:collectionCid",
                            element: /*#__PURE__*/_jsx(ExploreApplicationsPage, {})
                          }), /*#__PURE__*/_jsx(Route, {
                            path: "*",
                            element: /*#__PURE__*/_jsx(NotFound, {})
                          })]
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  })
}));
reportWebVitals();
setTimeout(() => {
  sdk.actions.ready().catch(e => {
    console.error("Farcaster Frame SDK not ready", e);
  });
}, 1000);